export class PriceNotFoundError extends Error {
  constructor(public productId: string) {
    super(`PRICE_NOT_FOUND: product=${productId}`);
    this.name = "PriceNotFoundError";
  }
}
export class PostingError extends Error {
  constructor(message: string) { super(message); this.name = "PostingError"; }
}
export class InsufficientStockError extends Error {
  constructor(public productId: string, public warehouseId: string) {
    super(`INSUFFICIENT_STOCK: product=${productId} warehouse=${warehouseId}`);
    this.name = "InsufficientStockError";
  }
}
